<script>
import { mapGetters } from 'vuex'
import _ from 'underscore'
import moment from "moment"
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

import Translatable from '@src/mixins/translatable.js'

import 'swiper/css/swiper.css'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  mixins: [
    Translatable
  ],
  props: {
    object: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      swiperOptions: {
        allowTouchMove: true,
        navigation: {
          nextEl: '.right-tab-control',
          prevEl: '.left-tab-control'
        },
        pagination: {
          el: '.schedule-pagination',
          clickable: true,
          bulletClass: 'small-bullet',
          bulletActiveClass: 'small-bullet-active'
        },
      },
      dateEntriesPerPage: 5,
      maxSum: 28
    }
  },
  computed: {
    ...mapGetters('translations', [
      'currentLanguage'
    ]),
    sortedOpeningDate() {
      return _.sortBy(this.object.opening, date => Date.parse(date.startDate))
    },
    actualSchedules() {
      const schedules = this.sortedOpeningDate
      return schedules.filter(schedule => moment().isBetween(schedule.startDate, schedule.endDate) || moment().isSameOrBefore(schedule.startDate))
    },
    actualSchedule() {
      const schedules = this.sortedOpeningDate
      return schedules.find(schedule => moment().isBetween(schedule.startDate, schedule.endDate) || moment().isSameOrBefore(schedule.startDate))
    },
    scheduleStyle() {
      return Object.entries(this.actualSchedule.data)
      .filter(item => item[1].length > 2)
      .length ? 'schedule-big' : 'schedule'
    },
    isPaginate() {
      return this.sliced(0).index < 7 || this.specialDatesPages(0).length || this.actualSchedules.length > 1 || this.actualSchedules[0].comment && this.sliced(0).sum >= 7
    }
  },
  methods: {
    workingTimeString(dates) {
      return dates.filter(date => date).join(', ')
    },
    specialDatesPages(i) {
      if (this.actualSchedules[i]) {
        const actualSpecialDates = this.actualSchedules[i].specialDates
        const specialDates = _.sortBy(actualSpecialDates.filter(date => date.isAvailable), date => Date.parse(date.date))
        if (specialDates.length > this.dateEntriesPerPage) {
          return _.chunk(specialDates, this.dateEntriesPerPage + 2)
        }

        return _.chunk(specialDates, this.dateEntriesPerPage)
      }
      return []
    },
    actualDate(i) {
      return Object.entries(this.actualSchedules[i].data).filter(item => item[1][0])
    },
    sliced(i) {
      let sum = 0
      let index = 0
      Object.entries(this.actualSchedules[i].data).forEach((item, i) => {
        if (sum < this.maxSum) {
          sum += item[1].filter(time => time).length
          index++
        }
      })

      return { index, sum }
    },
    getTitle(){
      this.object.opening.filter(season => season.isAvailable || season.isFuture)
      return this.object.opening === "hours" ? this.getTranslatedContent('OPENING_HOURS') : this.getTranslatedContent('STARTING_TIMES')
    },
    slicedArray(i) {
      if (this.actualSchedules[i]) {
        return [this.actualDate(i).slice(0, this.sliced(i).index), this.actualDate(i).slice(this.sliced(i).index)]
        .filter(date => date.length)
      }
      return []
    },
    formatMonDYYYY(date) {
      return moment(date).locale(this.currentLanguage || 'en').format('MMM, DD YYYY')
    }
  }
}
</script>

<template>
  <div class="content">
    <Swiper class="schedule-swiper" :options="swiperOptions">
      <template v-for="(el, i) in actualSchedules">
        <SwiperSlide v-for="(date, index) in slicedArray(i)" :key="index">
          <h5>{{actualSchedules[i].type === "hours" ? getTranslatedContent('OPENING_HOURS') : getTranslatedContent('STARTING_TIMES')}}</h5>
          <p class="season">{{ formatMonDYYYY(actualSchedules[i].startDate) }} - {{ formatMonDYYYY(actualSchedules[i].endDate) }} </p>
          <div :class="scheduleStyle">
            <div v-for="(item, index) in date" :key="index" class="schedule-item">
              <p class="weekday">{{ getTranslatedContent(`${item[0].toUpperCase()}`) | colon}} </p>
              <p class="time">{{ workingTimeString(item[1]) === 'closed' ? getTranslatedContent('CLOSED') : workingTimeString(item[1]) }}</p>
            </div>
            <div v-if="(actualSchedules[i].comment[currentLanguage] || actualSchedules[i].comment.en) && index === slicedArray(i).length - 1 && !specialDatesPages(i).length && sliced(0).sum < 7">
              <div class="underline"></div>
              <p class="schedule-tip">{{ actualSchedules[i].comment[currentLanguage] || actualSchedules[i].comment.en }}</p>
            </div>
          </div>
        </SwiperSlide>
        <template v-if="(actualSchedules[i].comment[currentLanguage] || actualSchedules[i].comment.en) && !specialDatesPages(i).length && sliced(0).sum >= 7">
          <SwiperSlide v-for="(date, index) in slicedArray(i)" :key="index" >
            <p class="season">{{ formatMonDYYYY(actualSchedules[i].startDate) }} - {{ formatMonDYYYY(actualSchedules[i].endDate) }} </p>
            <div :class="scheduleStyle">
              <div>
                <div class="underline"></div>
                <p class="schedule-tip">{{ actualSchedules[i].comment[currentLanguage] || actualSchedules[i].comment.en }}</p>
              </div>
            </div>
          </SwiperSlide>
        </template>
        <SwiperSlide v-for="(page, index) in specialDatesPages(i)" :key="index">
          <h5>{{actualSchedules[i].type === "hours" ? getTranslatedContent('OPENING_HOURS') : getTranslatedContent('STARTING_TIMES')}}</h5>
          <p class="season">{{ formatMonDYYYY(actualSchedules[i].startDate) }} - {{ formatMonDYYYY(actualSchedules[i].endDate) }} </p>
          <div class="schedule">
            <div v-for="item in page" :key="item.date" class="schedule-item">
              <p class="weekday">{{ item.date | ddmmYYYY }}</p>
              <p class="time">{{ item.hours === 'closed' ? getTranslatedContent('CLOSED') : item.hours }}</p>
            </div>
            <div v-if="(actualSchedules[i].comment[currentLanguage] || actualSchedules[i].comment.en) && index === specialDatesPages(i).length - 1">
              <div class="underline"></div>
              <p class="schedule-tip">{{ actualSchedules[i].comment[currentLanguage] || actualSchedules[i].comment.en}}</p>
            </div>
          </div>
        </SwiperSlide>
      </template>
      <div v-if="isPaginate" slot="pagination" class="schedule-pagination"></div>
      <div slot="button-prev" class="left-tab-control"></div>
      <div slot="button-next" class="right-tab-control"></div>
    </Swiper>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.content {
  box-sizing: border-box;
}

.season {
  margin-top: 6px;
  margin-bottom: 10px;
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: $orange;
  text-align: center;
}

.schedule, .schedule-big {
  margin-right: auto;
  margin-left: auto;
  width: 100%;
  height: 240px;

  & .schedule-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
    width: 219px;
    margin-right: auto;
    margin-left: auto;

    p {
      font-family: Open Sans, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 18px;
      color: $white;
    }

    .time {
      text-transform: uppercase;
    }

    .weekday {
      text-transform: capitalize;
      margin-right: 20px;
    }
  }

  .underline {
    height: 0;
    width: 260px;
    opacity: 0.2;
    border: 1px solid $light-gray;

    margin-right: auto;
    margin-left: auto;
  }

  .schedule-tip {
    font-family: Open Sans, sans-serif;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: $white;
    margin-top: 4px;
    margin-left: auto;
    margin-right: auto;
    width: 253px;
    text-align: left;
  }
}

.schedule-big {
  width: auto;
  padding: 0 50px 0 48px;

  & .schedule-item {
    width: auto;

    .time {
      text-align: left;
      // width: 100%;
      max-width: 168px;
    }
  }
}

h5 {
  font-family: Open Sans Bold, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  text-align: center;

  color: $white;
  margin-top: 30px;
}

h3 {
  font-family: Open Sans Bold, sans-serif;
  font-size: 22px;
  line-height: 29px;
  color: $white;
}

.control-mixin {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 140px;
  cursor: pointer;

  &.swiper-button-disabled {
    display: none;
  }
}

.left-tab-control {
  @extend .control-mixin;
  left: 10px;
  background: url("../../assets/icons/left.svg");
}

.right-tab-control {
  @extend .control-mixin;
  right: 10px;
  background: url("../../assets/icons/right.svg");
}

::v-deep .schedule-pagination {
  position: absolute;
  bottom: 10px;
  display: flex;
  justify-content: center;
  height: 5px;

  .small-bullet-active,
  .small-bullet {
    height: 5px;
    width: 5px;
    border-radius: 2.5px;
    cursor: pointer;
  }

  .small-bullet {
    background: $white;
    opacity: 1;
    margin-right: 5px;

    :last-child {
      margin-right: 0;
    }
  }

  .small-bullet-active {
    background: $orange;
  }
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {

  .schedule-big {
    width: auto;
    padding: 0 20px 0 20px;

    & .schedule-item {
      width: auto;

      .time {
        text-align: left;
      }
    }
  }

  .control-mixin {
    top: 1px;
  }
}

</style>
